function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 2C11.4477 2 11 2.44772 11 3V6.9126L9.39816 5.24928L9.30655 5.16708C8.98667 4.92041 8.53199 4.94677 8.24087 5.24682C7.92064 5.57687 7.91958 6.11308 8.2385 6.44449L11.4202 9.75072L11.5121 9.83313C11.8329 10.0803 12.2891 10.0529 12.5798 9.75072L15.7615 6.44449L15.8405 6.34934C16.0776 6.01729 16.0502 5.54686 15.7591 5.24682L15.6672 5.16501C15.3463 4.9197 14.8918 4.948 14.6018 5.24928L13 6.91316V3C13 2.44772 12.5523 2 12 2Z",
  fill: "#555770"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 22C12.5523 22 13 21.5523 13 21V17.0874L14.6018 18.7507L14.6935 18.8329C15.0133 19.0796 15.468 19.0532 15.7591 18.7532C16.0794 18.4231 16.0804 17.8869 15.7615 17.5555L12.5798 14.2493L12.4879 14.1669C12.1671 13.9197 11.7109 13.9471 11.4202 14.2493L8.2385 17.5555L8.15945 17.6507C7.92241 17.9827 7.94975 18.4531 8.24087 18.7532L8.33282 18.835C8.65367 19.0803 9.10824 19.052 9.39816 18.7507L11 17.0868V21C11 21.5523 11.4477 22 12 22Z",
  fill: "#555770"
});

function SvgMerge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.3cb9111d.svg";
export { ForwardRef as ReactComponent };